'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _filterBar = require('./filterBar.html');

var _filterBar2 = _interopRequireDefault(_filterBar);

var _searchAddToSavedModal = require('./searchAddToSavedModal.html');

var _searchAddToSavedModal2 = _interopRequireDefault(_searchAddToSavedModal);

var _searchSavedList = require('./searchSavedList.html');

var _searchSavedList2 = _interopRequireDefault(_searchSavedList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filterBar = {
    bindings: {
        placeholder: '@',
        search: '=',
        searchText: '=',
        disableField: '=',
        page: '@',
        onSave: '=',
        getSavedList: '=',
        onSaveApply: '=',
        onSaveDelete: '='
    },
    template: _filterBar2.default,
    controller: function controller($ionicScrollDelegate, $scope, $ionicModal, $ionicPopover) {
        var _this = this;

        this.saveSearchName = '';
        this.list = [];

        this.addToFavorite = $ionicModal.fromTemplate(_searchAddToSavedModal2.default, {
            scope: $scope
        });

        this.$ionicScrollDelegate = $ionicScrollDelegate;

        this.performSearch = function () {
            if (!_this.page) _this.$ionicScrollDelegate.scrollTop();
            _this.search(_this.searchText);
        };

        this.showModal = function () {
            _this.saveSearchName = '';
            _this.addToFavorite.show();
        };

        this.showSaved = function ($event) {
            if (!_this.getSavedList) {
                return;
            }

            _this.getSavedList().then(function (data) {
                if (data) {
                    _this.list = data;
                }
            });

            _this.popover = $ionicPopover.fromTemplate(_searchSavedList2.default, {
                scope: $scope
            });

            _this.popover.show($event);
        };

        this.onChange = function ($event) {
            _this.popover.hide();
        };

        this.hide = function () {
            _this.addToFavorite.hide();
        };

        this.save = function () {
            _this.onSave(_this.saveSearchName);
            _this.hide();
        };

        this.apply = function (item) {
            _this.onSaveApply(_extends({}, item.filter));
            _this.popover.hide();
        };

        this.remove = function ($event, item) {
            $event.stopPropagation();

            _this.onSaveDelete(item.filterName);
            _this.list = _this.list.filter(function (searchItem) {
                return searchItem.filterName !== item.filterName;
            });
        };
    }
};

exports.default = filterBar;


/** WEBPACK FOOTER **
 ** ./src/app/directives/filterBar/filterBar.js
 **/